import React, { PureComponent } from "react";
import { connect } from 'react-redux';
import { compose } from "redux";
import { withTranslation } from "react-i18next";

import { showCreatedSticker } from "../../../store/create-llama/actions";
import StickersComponentsCongratulations from "../../components/congratulations";
import {
  createLlamaShowAnimationSelector
} from "../../../store/create-llama/selectors";
class StickersScreensNewStickerFinish extends PureComponent {

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <StickersComponentsCongratulations
        title={this.props.t('title')}
        viewItPressed={this.props.showCreatedSticker}
        showAnimation={this.props.showAnimation}
        history={ this.props.history }
        canAddStickerItem={ false }
        containerStyle={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1101, overflowY: 'auto' }}
      />
  );
  }
}

const mapStateToProps = (state) => {
  return {
    showAnimation: createLlamaShowAnimationSelector(state),
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    showCreatedSticker: () => dispatch(showCreatedSticker())
  }
};

export default compose(
  withTranslation('scr-new-sticker-finish'),
  connect(mapStateToProps, mapDispatchToProps)
)(StickersScreensNewStickerFinish);